module.exports = __webpack_public_path__ + "static/media/newmedia-bg.cb717843.webp";